import { Component, Input, OnInit } from '@angular/core';
import { WidgetComponent } from '@widgets/widgets';
import { MetricApplicability } from '@widgets/models/MetricApplicability';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lms-applicability',
  templateUrl: './applicability.component.html',
  styleUrls: ['./applicability.component.scss']
})
export class ApplicabilityComponent implements WidgetComponent, OnInit {
  @Input() public data: any;

  public courseOptionList: { key: string; value: string }[] = [];
  public selectedCourse: { key: string; value: string } = null;

  public isEmpty: boolean = true;
  public metricApplicabilityData: MetricApplicability;
  public clientId: string;

  constructor(private translateService: TranslateService) {}

  public ngOnInit(): void {
    this.isEmpty = !!this.data.metricApplicability?.empty;

    if (!this.isEmpty) {
      this.metricApplicabilityData = this.data.metricApplicability;
      const client = this.data.managedAccounts.length === 1 ? this.data.managedAccounts[0] : null;
      this.clientId = client ? client.id : null;

      this.courseOptionList = this.getApplicabilityCourseList(this.data.metricApplicability?.courses || []);
      this.selectedCourse = this.courseOptionList ? this.courseOptionList[0] : null;
    }
  }

  /**
   * Get the course list of applicability for the dropdown
   * @param courseList
   * @private
   */
  private getApplicabilityCourseList(courseList: any[]) {
    const courseOptionList = this.setCourseListOptions(courseList);
    courseOptionList.unshift({
      key: 'all',
      value: this.translateService.instant('dashboard.widgets.applicabilityAllOption')
    });
    return courseOptionList;
  }

  /**
   * Set the list of courses for the select
   * @param applicabilityCourses
   * @private
   */
  private setCourseListOptions(applicabilityCourses: any[]): { key: string; value: string }[] {
    return applicabilityCourses
      .map((course: { courseId: string; courseName: string }) => ({
        key: course.courseId,
        value: course.courseName
      }))
      .sort((a, b) => (a.value > b.value ? 1 : a.value < b.value ? -1 : 0));
  }

  /**
   * Set the selected course
   * @param courseId
   */
  public setSelectedCourse(courseId): void {
    this.selectedCourse = this.courseOptionList.find((course: any) => course.key === courseId);
    const isSelectedCourse = this.selectedCourse.key !== 'all';
    this.metricApplicabilityData = isSelectedCourse
      ? this.data.metricApplicability['courses'].find((course) => course.courseId === courseId)
      : this.data.metricApplicability;
  }
}
